import { Box } from "@mui/material";

import { TemplateEditorView } from "./TemplateEditorView";
import { TemplateThumbnailView } from "./TemplateThumbnailView";
import { TemplateEditForm } from "./TemplateEditForm";

export function TemplateLayoutView() {
  return (
    <Box
      sx={{
        marginTop: "20px",
        position: "relative",
      }}
    >
      <TemplateThumbnailView />
      <TemplateEditorView />
      <TemplateEditForm />
    </Box>
  );
}
